import { Box } from '@mui/material';
import { useNavigate } from 'react-router';
import { lazy, Suspense, useEffect } from 'react';
import LoadingProgress from 'src/components/app/LoadingProgress';
import PageMeta from 'src/components/app/PageMeta';

const MenuItemsList = lazy(() => import('../../components/settings/menuItems/MenuItemsList'));

const MenuItems = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/settings/channels', { replace: true });
  }, []);
  
  return (
    <>
      <PageMeta title="Channels" />
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          px: {
              xs: 1,
              md: 2
          },
          py: {
            xs: 1,
            md: 2
          }
        }}
      >
        <Suspense fallback={<LoadingProgress open />}>
          <MenuItemsList showFab showBreadcrumbs configUrl="/channels" />
        </Suspense>
      </Box>
    </>
  );
};

export default MenuItems;
